import moment from 'moment'

export function toMoney(amount) {
    if (!amount || isNaN(amount)) return '0'

    try {
        var decimalCount = 2
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const decimals = '.'
        const thousands = ','
        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign
            + (j ? i.substr(0, j) + thousands : '')
            + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
            (decimalCount ? decimals + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '');
    } catch (error) {
        return ''
    }
}
export function toTwoDecimal(amount) {
    return Math.round(amount * 100) / 100
}
export function toDateDDMMYYY(date) {
    if (!date) return ''
    return moment.utc(date).format('DD/MM/YYYY')
}

export function toDateYYMMDD(date) {
    if (!date) return ''
    return moment.utc(date).format('YYYY/MM/DD')
}

export function toGender(value) {
    if (value == 'M') return 'Masculino'
    else if (value == 'F') return 'Femenino'
    else if (value == 'OTHER') return 'Otros'
    else return ''
}

export function toBlankCategory(category) {
    if (!category) return 'Sin Categoría'
    return category.name;
}
export function toBlankDiscount(discount) {
    if (!discount) return 'Sin Descuento'
    return `${discount * 100} %`;
}

export function toBlankRUC(ruc) {
    if (!ruc) return 'Sin RUC'
    return ruc;
}

export function cloneObject(obj) {
    return JSON.parse(JSON.stringify(obj));
}

//Quotation
export function toBlankUnitDiscount(discount, typeDiscount) {
    if (!discount) return 'Sin Descuento'
    return typeDiscount == "true" ? `${toTwoDecimal(discount / 100)} %` : toMoney(discount);
}
export function toBlankDiscountDetail(discount, typeDiscount) {
    if (!discount) return 'Sin Descuento'
    return typeDiscount == "true" ? `${toTwoDecimal(discount)} %` : toMoney(discount);
}
export function totalPriceDiscounted(total, discount, typeDiscount) {
    if (!discount) return toMoney(total);
    return typeDiscount == "true" ? toMoney(total * (1 - discount)) : toMoney(total - discount);
}


// WEBPACK FOOTER //
// ./src/common/helpers/format.js